import { resolveMediaUrl } from "../../api";
import { formatPrice } from "../../shop/formatPrice";
import { IconBag } from "./ShopIcons";

function ProductCard({ product, t, lang, inCart, onOpen, onAdd }) {
  const name = (lang === "en" && product.nameEn) || product.nameHu;
  const description = (lang === "en" && product.descriptionEn) || product.descriptionHu;

  return (
    <article className={product.available ? "shop-card" : "shop-card is-sold-out"}>
      <button
        type="button"
        className="shop-card-media"
        onClick={() => onOpen(product)}
        aria-label={`${t.details}: ${name}`}
      >
        {product.imageUrl ? (
          <img src={resolveMediaUrl(product.imageUrl)} alt="" loading="lazy" />
        ) : (
          <img src="/img/mizulogo.png" alt="" className="shop-card-placeholder" />
        )}
        {!product.available ? <span className="shop-card-badge">{t.soldOut}</span> : null}
      </button>

      <div className="shop-card-body">
        <p className="shop-card-category">{t.categories[product.category] || ""}</p>
        <h3 className="shop-card-name">
          <button type="button" onClick={() => onOpen(product)}>
            {name}
          </button>
        </h3>
        {description ? <p className="shop-card-desc">{description}</p> : null}

        <div className="shop-card-footer">
          <p className="shop-card-price">
            {formatPrice(product.priceHuf)}
            {product.unitLabel ? <span> / {product.unitLabel}</span> : null}
          </p>
          <button
            type="button"
            className={inCart ? "shop-add is-added" : "shop-add"}
            disabled={!product.available}
            onClick={() => onAdd(product)}
          >
            <IconBag className="shop-add-icon" />
            {product.available ? (inCart ? t.added : t.addToCart) : t.soldOut}
          </button>
        </div>
      </div>
    </article>
  );
}

export default ProductCard;
